export class OfferStats {
  allCount: number;
  lostCount: number;
  openCount: number;
  realizedMonthlyCosts: number;
  realizedUniqueCosts: number;
  potentialMonthlyCosts: number;
  potentialUniqueCosts: number;
  wonCount: number;

  constructor() {
    this.allCount = 0;
    this.lostCount = 0;
    this.openCount = 0;
    this.realizedMonthlyCosts = 0;
    this.realizedUniqueCosts = 0;
    this.potentialMonthlyCosts = 0;
    this.potentialUniqueCosts = 0;
    this.wonCount = 0;
  }
}



// WEBPACK FOOTER //
// ./src/models/offerStats.ts